import Vue from "vue";
import Vuex from "vuex";
import axios from 'axios';
import api from "./constants/api";
import io from "socket.io-client";
import { setMomentTime } from "@/util";
import { Client } from "@twilio/conversations";
import firebase from "firebase/app";
import "firebase/messaging";
import i18n from "@/i18n";

Vue.use(Vuex);


export default new Vuex.Store({
    state: {
        user: JSON.parse(localStorage.getItem('user')),
        notifications: JSON.parse(localStorage.getItem('notifications')) || [],
        unreadMessage: localStorage.getItem('unreadMessage') || 0,
        unreadMessageConversation: localStorage.getItem('unreadMessageConversation') || "",
        conversationClient: null,
        socket: null,
        userCancellationReason:[],
        complaintCategories:[],
        ai_status: {
            snoozed_at: null,
            snooze_interval: 0,
            dispatch_interval: 0,
            ai_stopped: '0'
        },
        selectedSeason: 'night',
        // besoins:JSON.parse(localStorage.getItem('besoins')) || [],
    },
    getters: {
        getSelectedSeason(state) {
            return state.selectedSeason;
        },
        getConversationClient(state) {
            return state.conversationClient;
        },
        getUnreadMessage(state) {
            return state.unreadMessage;
        },
        getUnreadMessageConversation(state) {
            return state.unreadMessageConversation;
        },
        getUserCancellationReason(state){
            return state.userCancellationReason;
        },
        getComplaintCategories(state){
            return state.complaintCategories;
        }
    },
    mutations: {
        // SET_BESOIN(state,value){
        //     // state.besoins.push(value);
        //     state.besoins = [...state.besoins, value];
        //     localStorage.setItem('besoins', JSON.stringify(state.besoins));
        // },
        // DELETE_BESOIN(state, value){
        //     var index = state.besoins.findIndex(besoin => besoin == value);
        //     state.besoins.splice(index, 1);
        //     localStorage.setItem('besoins', JSON.stringify(state.besoins));
        // },
        setSeason(state, value) {
            state.selectedSeason = value;
        },
        setUserCancellationReason(state, value) {
            state.userCancellationReason = value;
        },
        setComplaintCategories(state, value) {
            state.complaintCategories = value;
        },
        setTwilioClient(state, client) {
            state.conversationClient = client;
        },
        setUnreadMessage(state, unreadMessage) {
            state.unreadMessage = unreadMessage;
            localStorage.setItem("unreadMessage", unreadMessage);
        },
        setUnreadMessageConversation(state, unreadMessageConversation) {
            state.unreadMessageConversation = unreadMessageConversation;
            localStorage.setItem(
                "unreadMessageConversation",
                unreadMessageConversation
            );
        },
        SET_ONLINE(state, value) {
            state.user = Object.assign({}, state.user, { online: value })
        },
        SET_AI_STATUS(state, status) {
            state.ai_status = status;
        },
        USER_NAME(state, USER_NAME) {
            state.USER_NAME = USER_NAME;
        },
        LOGIN(state, user) {
            state.user = user;
            setMomentTime(user.timestamp);
            axios.defaults.headers.common['Authorization'] = `Bearer ${user.accessToken}`;
            localStorage.setItem('user', JSON.stringify(user));
        },
        LOGOUT(state) {
            try {
                axios.defaults.headers.common['Authorization'] = ``;
                state.user = null;
                localStorage.removeItem('user');
                localStorage.removeItem('notifications');
                if (state.socket) state.socket.disconnect();
            } catch (e) {
                console.log(e);
            }
        },
        NEW_NOTIFICATION(state, notification) {
            state.notifications = [...state.notifications, notification];
            localStorage.setItem('notifications', JSON.stringify(state.notifications));
        },
        INIT_SOCKET(state) {
            state.socket = io(api.SOCKET.USERS, {
                transportOptions: {
                    polling: {
                        extraHeaders: axios.defaults.headers.common
                    }
                }
            });
            // state.socket.on('error', (err) => console.log('SOCKET ERROR', err));

            //TODO: disable receive notifications for specific roles, it must be as permission

            if (state.user && [11, 12].includes(state.user.roles[0].id)) {
                state.socket = {};
                return;
            }

            state.socket.on('connect', () => {
                console.log("connected");
            })

            state.socket.on(api.SOCKET.EVENTS.NEW_NOTIFICATION, ({ message, datetime = +new Date(), color = 'orange' }) => this.commit('NEW_NOTIFICATION', {
                message,
                color,
                datetime
            }));
            state.socket.on('Ai:status_updated', ai_status => this.commit('SET_AI_STATUS', ai_status));
            state.socket.on('Dashboard:new_passenger', (passenger) => {
                const withDocs = !!(passenger.id_card_front || passenger.id_card_back);
                this.commit("NEW_NOTIFICATION", {
                    color: "grey",
                    message: i18n.t(withDocs ? "communication.store.newPassengerWithDocs" : "communication.store.newPassengerWithoutDocs", { firstName: passenger.first_name, lastName: passenger.last_name }),
                    datetime: +new Date()
                });
                // (new Audio(new_passenger_registered)).play();
            });
        }
    },
    actions: {
        async validateToken({ commit, state }, token = null) {
            try {
                let baseUser;
                if (!token) {
                    baseUser = state.user;
                    token = baseUser.accessToken;
                } else {
                    baseUser = {
                        accessToken: token
                    }
                }

                axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                const { data: { data: user } } = await axios.get(api.ACTIONS.CHECK_TOKEN);
                await commit('LOGIN', Object.assign({}, baseUser, user));
                await commit('SET_AI_STATUS', user.ai_status);
            } catch (e) {
                commit('LOGOUT');
            }
        },

        async initSocket({ commit, state }) {
            if (state.socket) state.socket.disconnect();
            commit('INIT_SOCKET');
        },
        async initTwilioConnection({ commit, state, dispatch }) {
            if (state.user.accessToken) {
                await axios.get(api.ACTIONS.TWILIO_TOKEN)
                    .then(async ({ data }) => {
                        let client = await new Client(data.data);
                        client.conversations = {};
                        commit('setTwilioClient', client);

                        const refreshToken = async () => {
                            try {
                                const { data: tokenData } = await axios.get(api.ACTIONS.TWILIO_TOKEN);
                                await client.updateToken(tokenData.data);
                                console.log("Twilio token refreshed.");
                            } catch (err) {
                                console.error("Failed to refresh Twilio token:", err);
                            }
                        };

                        client.on('tokenAboutToExpire', refreshToken);
                        client.on('tokenExpired', refreshToken);

                        client.on('connectionStateChanged', async (status) => {
                            if (status === 'disconnected') {
                                console.log("Twilio disconnected. Attempting token refresh...");
                                refreshToken();
                            }
                            if (status === 'connected') {
                                if (!firebase.apps.length) {
                                    await firebase.initializeApp({
                                        apiKey: "AIzaSyDLXopouJSP0rFRuX9BMhxWiEHkmWhCX_s",
                                        authDomain: "monaco-taxi-chauffeur.firebaseapp.com",
                                        projectId: "monaco-taxi-chauffeur",
                                        storageBucket: "monaco-taxi-chauffeur.appspot.com",
                                        messagingSenderId: "24902159594",
                                        appId: "1:24902159594:web:a04599ecf8d00276159b93",
                                        measurementId: "G-ZTEKXRQJXB"
                                    });
                                }

                                if (firebase && firebase.messaging()) {
                                    // requesting permission to use push notifications
                                    firebase.messaging().requestPermission().then(() => {
                                        // getting FCM token
                                        firebase.messaging().getToken().then((fcmToken) => {
                                            // passing FCM token to the `conversationClientInstance` to register for push notifications
                                            client.setPushRegistrationId('fcm', fcmToken);
                                            // registering event listener on new message from firebase to pass it to the Conversations SDK for parsing
                                            firebase.messaging().onMessage((payload) => {
                                                const notificationTitle = payload.data.conversation_title;
                                                const notificationOptions = {
                                                    body: payload.data.twi_body,
                                                    icon: '/apple-icon.png'
                                                };
                                                let notification = new Notification(notificationTitle, notificationOptions);
                                                notification.onclick = (event) => {
                                                    window.open(event.target.origin + `/messages?conversation=${event.notification.data.conversation_sid}`);
                                                    notification.close();
                                                }
                                            });

                                        }).catch((err) => {
                                            console.log('Error', err)
                                        });
                                    }).catch((err) => {
                                        // can't request permission or permission hasn't been granted to the web app by the user
                                        console.log('Error', err)
                                    });
                                } else {
                                    // no Firebase library imported or Firebase library wasn't correctly initialized
                                }
                            }
                        });
                    })
                    .catch((err) => {
                        console.error(err);
                    })
            }
        },
        getOrders(_context, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(api.ACTIONS.BOOKINGS, { params: data })
                    .then((response) => {
                        resolve(response.data.data);
                    })
                    .catch((error) => {
                        if (error.message == "Network Error" && !error.response) {
                            reject(i18n.t("communication.store.checkConnection"));
                        } else {
                            reject(error.response.data.message);
                        }
                    });
            });
        },
        setUnreadMessagePreference(_context, unreadMessage) {
            localStorage.setItem("unreadMessage", unreadMessage);
            _context.commit("setUnreadMessage", unreadMessage);
        },
        setUnreadMessageConversationPreference(_context, unreadMessageConversation) {
            localStorage.setItem(
                "unreadMessageConversation",
                unreadMessageConversation
            );
            _context.commit("setUnreadMessageConversation", unreadMessageConversation);
        },
        getOrdersPageData(_context, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(api.ACTIONS.BOOKINGS, {
                        params: data,
                    })
                    .then((response) => {
                        resolve(response.data.data);
                    })
                    .catch((error) => {
                        if (error.message == "Network Error" && !error.response) {
                            reject(i18n.t("communication.store.checkConnection"));
                        } else {
                            reject(error.response.data.message);
                        }
                    });
            });
        },
        advancedSearch(_context, data) {
            return new Promise((resolve, reject) => {
                axios.get(api.ACTIONS.ADVANCED_SEARCH, {
                    params: data
                })
                    .then(response => {
                        resolve(response.data.data)
                    })
                    .catch(error => {
                        if (error.message == "Network Error" && !error.response) {
                            reject(i18n.t("communication.store.checkConnection"));
                        } else {
                            reject(error.response.data.message);
                        }
                    })
            })
        },
        getSeason({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get(api.ACTIONS.SETTINGS, {
                    params: {
                        key: 'SEASON'
                    }
                })
                    .then(res => {
                        commit('setSeason', res.data.data['SEASON'] || '');
                        resolve(res.data.data['SEASON']);
                    })
                    .catch(err => {
                        if (err.message == "Network Error" && !err.response) {
                            reject(i18n.t("communication.store.checkConnection"));
                        } else {
                            reject(err.response.data.message);
                        }
                    })
            })
        },
        getUserCancellationReasons({ commit, state }) {
            if (state.userCancellationReason.length>0) {
                return state.userCancellationReason;
              }
            return new Promise((resolve, reject) => {
                axios.get(api.ACTIONS.USER_CANCELLATION_REASONS)
                    .then(res => {
                        commit('setUserCancellationReason', res.data.data || []);
                        resolve(res.data.data);
                    })
                    .catch(err => {
                        if (err.message == "Network Error" && !err.response) {
                            reject(i18n.t("communication.store.checkConnection"));
                        } else {
                            reject(err.response.data.message);
                        }
                    })
            })
        },
        fetchComplaintCategories({ commit, state }) {
            if (state.complaintCategories.length>0) {
                return state.complaintCategories;
              }
            return new Promise((resolve, reject) => {
                axios.get("complaint-category")
                    .then(res => {
                        commit('setComplaintCategories', res.data.data || []);
                        resolve(res.data.data);
                    })
                    .catch(err => {
                        if (err.message == "Network Error" && !err.response) {
                            reject(i18n.t("communication.store.checkConnection"));
                        } else {
                            reject(err.response.data.message);
                        }
                    })
            })
        }
    }
});

